<template>
  <div
    @mouseenter.stop="showTooltip = true"
    @mouseleave.stop="showTooltip = false"
  >
    <!-- <div
      class="g-gantt-bar"
      ref="g-gantt-bar"
      :style="barStyle"
      @mouseenter.stop="onMouseenter($event)"
      @mouseleave.stop ="onMouseleave($event)"
      @mousedown.stop="onMousedown($event)"
      @dblclick="onDblclick($event)"
      @contextmenu="onContextmenu($event)"
    > -->
    <div
      class="g-gantt-bar"
      :class="`box-shadow-${this.barConfig.class}`"
      ref="g-gantt-bar"
      :style="barStyle"
    >
      <div
        class="g-gantt-bar-label"
        :class="`bg-${this.barConfig.class}`"
        draggable="true"
      >
        <slot
          name="bar-label"
          :bar="bar"
        >
          {{barConfig.label || ""}}
        </slot>
        <div class="controls-container"
             v-if="showControls"
             :class="{controlsAbsolute: !isControlsAbsolute}"
        >
          <slot
            name="bar-edit-button"
            :bar="bar"
          />
          <b-button
            variant="dark"
            size="sm"
            v-b-tooltip.hover
            title="Move"
            class="barActionBtn"
            @mouseup.stop="onMouseup($event, 'drag')"
            @mousedown.stop="onMousedown($event, 'drag')"
            @contextmenu="onContextmenu($event)"
          >
            <icon name="arrows-h" />
          </b-button>
        </div>
      </div>
      <template v-if="barConfig.handles">
        <div class="g-gantt-bar-handle-left"
          @mouseup.stop="onMouseup($event, 'dragByHandleLeft')"
             @mousedown.stop="onMousedown($event, 'dragByHandleLeft')">
          <icon name="angle-left" />
        </div>
        <div class="g-gantt-bar-handle-right"
          @mouseup.stop="onMouseup($event, 'dragByHandleRight')"
             @mousedown.stop="onMousedown($event, 'dragByHandleRight')">
          <icon name="angle-right" />
        </div>
      </template>
    </div>

    <transition name="fade" mode="out-in">
      <div
        v-if="showTooltip && !isDragging"
        class="g-gantt-tooltip"
        :style="tooltipStyle"
      >
        <div
          class="color-indicator"
          :style="{background: this.barStyle.background || this.barStyle.backgroundColor}"
        />
        {{bar[barStart] | TimeFilter}}
        -
        {{bar[barEnd] | TimeFilter}}
      </div>
    </transition>

  </div>
</template>

<script>
import moment from 'moment'

export default {
  name: "GGanttBar",

  props:{
    bar: {type: Object},
    barStart: {type: String}, // property name of the bar objects that represents the start datetime
    barEnd: {type: String}, // property name of the bar objects that represents the end datetime,
    barContainer: [Object, DOMRect],
    allBarsInRow: {type: Array}
  },

  inject: [
    // "getHourCount",
    "ganttChartProps",
    "initDragOfBarsFromBundle",
    "moveBarsFromBundleOfPushedBar",
    "setDragLimitsOfGanttBar",
    "onBarEvent",
    "onDragendBar",
    "getChartStart",
    "getChartEnd",
  ],

  data(){
    return {
      showTooltip: false,
      tooltipTimeout: null,
      dragLimitLeft: null,
      dragLimitRight: null,
      isDragging: false,
      isMainBarOfDrag: false, // is this the bar that was clicked on when starting to drag
                              // or is it dragged along some other bar from the same bundle
      cursorOffsetX: 0,
      barStartBeforeDrag: null,
      barEndBeforeDrag: null,
      localStartMoment: null,
      localEndMoment: null,
    }
  },

  created() {
      this.localStartMoment = this.mapTimeToPosition(this.barStartMoment)
      this.localEndMoment = this.mapTimeToPosition(this.barEndMoment)
  },

  computed:{
    // use these computed moment objects to work with the bar's start/end dates:
    // instead of directly mutating them:
    showControls() {
        return this.barWidthCheck(this.barStyle.width, 125)
    },
    isControlsAbsolute() {
        return this.barWidthCheck(this.barStyle.width, 300)
    },
    barStartMoment:{
      get(){
        return moment(this.bar[this.barStart])
      },
      set(value){
        this.bar[this.barStart] = moment(value).format("YYYY-MM-DD HH:mm:ss")
      }
    },

    barEndMoment: {
      get(){
        return moment(this.bar[this.barEnd])
      },
      set(value){
        this.bar[this.barEnd] = moment(value).format("YYYY-MM-DD HH:mm:ss")
      }
    },

    barConfig(){
      return this.bar.ganttBarConfig || {}
    },

    barStyle(){
      return {
        ...(this.barConfig || {}),
        left: `${this.localStartMoment}px`,
        width: `${this.localEndMoment - this.localStartMoment}px`,
        height: `${this.ganttChartProps.rowHeight-26}px`,
        zIndex: this.isDragging ? 2 : 1,
        top: '11px',
      }
    },

    tooltipStyle(){
      return{
        left: this.barStyle.left,
        top:`${this.ganttChartProps.rowHeight - 10}px`,
      }
    },

    chartStartMoment(){
      return moment(this.ganttChartProps.chartStart)
    },

    chartEndMoment(){
      return moment(this.ganttChartProps.chartEnd)
    },
    newHoursCounter(){
      return (this.barContainer.width/this.ganttChartProps.scaleSize) * (this.ganttChartProps.scaleDays * 24)
    },
  },

  methods:{
    barWidthCheck(value, moreThen) {
        return Number(value.replace('px', '')) > moreThen
    },
    onMouseup(e){
      this.endDrag(e)
      window.removeEventListener("mousemove", this.onFirstMousemove, false)
    },

    // onMouseenter(e){
    //   if(this.tooltipTimeout){
    //     clearTimeout(this.tooltipTimeout)
    //   }
    //   this.tooltipTimeout = setTimeout(() => this.showTooltip = true, 800)
    //   this.onBarEvent(e, this)
    // },

    // onMouseleave(e){
    //   clearTimeout(this.tooltipTimeout)
    //   this.showTooltip = false
    //   this.onBarEvent(e, this)
    // },

    onContextmenu(e){
      this.onBarEvent(e, this)
    },

    onMousedown(e, eventName){
      this.eventName = eventName
      e.preventDefault()
      if(e.button === 2 || this.barConfig.immobile){
        return
      }
      // document.body.style.cursor = "move"
      this.setDragLimitsOfGanttBar(this)
      // initialize the dragging on next mousemove event:
      window.addEventListener("mousemove", this.onFirstMousemove, {once: true})
      // this.onBarEvent(e, this)
    },

    onFirstMousemove(e){
      this.isMainBarOfDrag = true
      // this method is injected here by GGanttChart.vue, and calls initDrag()
      // for all GGanttBars that belong to the same bundle as this bar:
      this.initDragOfBarsFromBundle(this, e)
    },

    /* --------------------------------------------------------- */
    /* ------------- METHODS FOR DRAGGING THE BAR -------------- */
    /* --------------------------------------------------------- */
    initDrag(e){  // "e" must be the mousedown event
      this.isDragging = true
      this.barStartBeforeDrag = this.localStartMoment
      this.barEndBeforeDrag =  this.localEndMoment
      let barX = this.$refs["g-gantt-bar"].getBoundingClientRect().left
      this.cursorOffsetX = e.clientX - barX
      window.addEventListener("mousemove", this[this.eventName])
      window.addEventListener("mouseup", this.endDrag)
    },

    drag(e){
      let barWidth = Number(this.barStyle.width.replace('px', ''));
      let newXStart = (e.clientX-this.barContainer.left) - this.cursorOffsetX
      let newXEnd = newXStart + barWidth
      this.localStartMoment = newXStart
      this.localEndMoment = newXEnd
/*      if(this.isPosOutOfDragRange(newXStart, newXEnd) || !newStartMoment.isSameOrAfter(this.getChartStart()) || !newEndMoment.isSameOrBefore(this.getChartEnd())){
        return
      }
      this.barStartMoment = newStartMoment
      this.barEndMoment = newEndMoment
      this.manageOverlapping()*/
      // this.onBarEvent({...e, type: "drag"}, this)
    },

    dragByHandleLeft(e){
      let newXStart = e.clientX - (this.barContainer.left + 15)
      this.localStartMoment = newXStart

/*      let newStartMoment = this.mapPositionToTime(newXStart)
      if(newStartMoment.isSameOrAfter(this.barEndMoment) || this.isPosOutOfDragRange(newXStart, null) || !newStartMoment.isSameOrAfter(this.getChartStart())){
        return
      };
      this.barStartMoment = newStartMoment
      this.manageOverlapping()*/
    },

    dragByHandleRight(e){
      let newXEnd = e.clientX - (this.barContainer.left - 15)
      this.localEndMoment = newXEnd

/*      let newEndMoment = this.mapPositionToTime(newXEnd)
      if(newEndMoment.isSameOrBefore(this.barStartMoment) || this.isPosOutOfDragRange(null, newXEnd) || !newEndMoment.isSameOrBefore(this.getChartEnd())){
        return
      }
      this.barEndMoment = newEndMoment
      this.manageOverlapping()*/
    },

    isPosOutOfDragRange(xStart, xEnd){
      if(xStart && this.dragLimitLeft !== null && xStart < this.dragLimitLeft+2){
        return true
      }
      if(xEnd && this.dragLimitRight !== null && xEnd > this.dragLimitRight-2){
        return true
      }
      return false
    },

    setNewLocalValues(start, end) {
        this.localStartMoment = start;
        this.barStartBeforeDrag = start;
        this.localEndMoment = end;
        this.barEndBeforeDrag = end;
    },

    endDrag(e){
      this.isDragging = false
      this.dragLimitLeft = null
      this.dragLimitRight = null
      // document.body.style.cursor = "auto"
      window.removeEventListener("mousemove", this[this.eventName])
      window.removeEventListener("mouseup", this.endDrag)
        const newXStart = this.mapPositionToTime(this.localStartMoment)
        const newXEnd = this.mapPositionToTime(this.localEndMoment)

        if(this.localStartMoment !== this.barStartBeforeDrag && this.localEndMoment !== this.barEndBeforeDrag) {
            const w = this.localEndMoment - this.localStartMoment;
            if(!newXStart.isSameOrAfter(this.getChartStart())) {
                this.setNewLocalValues(this.mapTimeToPosition(this.getChartStart()), this.mapTimeToPosition(this.getChartStart()) + w)
            }
            else if(!newXEnd.isSameOrBefore(this.getChartEnd())) {
                this.setNewLocalValues(this.mapTimeToPosition(this.getChartEnd()), this.mapTimeToPosition(this.getChartEnd()) - w)
            }
        }
        if(!newXStart.isSameOrAfter(this.getChartStart())) {
          this.localStartMoment = this.mapTimeToPosition(this.getChartStart());
          this.barStartBeforeDrag = this.localStartMoment;
        }

        if(!newXEnd.isSameOrBefore(this.getChartEnd())) {
            this.localEndMoment = this.mapTimeToPosition(this.getChartEnd())
            this.barEndBeforeDrag = this.localEndMoment
        }

        this.barStartMoment = this.mapPositionToTime(this.localStartMoment)
        this.barEndMoment = this.mapPositionToTime(this.localEndMoment)
        this.manageOverlapping()
      if(this.isMainBarOfDrag){
        this.onDragendBar(e, this)
        this.isMainBarOfDrag = false
      }
    },

    snapBack(){
      this.barStartMoment = this.barStartBeforeDrag
      this.barEndMoment = this.barEndBeforeDrag
    },

    manageOverlapping(){
      if(!this.ganttChartProps.pushOnOverlap){
        return
      }
      let currentBar = this.bar

      let {overlapBar, overlapType} = this.getOverlapBarAndType(currentBar)

      while(overlapBar){
        let minuteDiff
        let currentStartMoment = moment(currentBar[this.barStart])
        let currentEndMoment = moment(currentBar[this.barEnd])
        let overlapStartMoment = moment(overlapBar[this.barStart])
        let overlapEndMoment  = moment(overlapBar[this.barEnd])
        switch(overlapType){
          case "left":
            minuteDiff = overlapEndMoment.diff(currentStartMoment, "minutes", true)
            overlapBar[this.barEnd] = currentBar[this.barStart]
            overlapBar[this.barStart] = overlapStartMoment.subtract(minuteDiff, "minutes", true)
            break
          case "right":
            minuteDiff = currentEndMoment.diff(overlapStartMoment, "minutes", true)
            overlapBar[this.barStart] = currentBar[this.barEnd]
            overlapBar[this.barEnd] = overlapEndMoment.add(minuteDiff, "minutes", true)
            break
          default:
            console.warn("One bar is inside of the other one! This should never occur while push-on-overlap is active!")
            return
        }
        this.moveBarsFromBundleOfPushedBar(overlapBar, minuteDiff, overlapType)
        currentBar = overlapBar;
        ({overlapBar, overlapType} = this.getOverlapBarAndType(overlapBar))
      }
    },

    getOverlapBarAndType(bar){
      let barStartMoment = moment(bar[this.barStart])
      let barEndMoment = moment(bar[this.barEnd])


      let overlapLeft, overlapRight, overlapInBetween
      let overlapBar = this.allBarsInRow.find(otherBar => {
        if(otherBar === bar){
          return false
        }
        let otherBarStart = moment(otherBar[this.barStart])
        let otherBarEnd = moment(otherBar[this.barEnd])

        overlapLeft = barStartMoment.isBetween(otherBarStart, otherBarEnd)
        overlapRight = barEndMoment.isBetween(otherBarStart, otherBarEnd)
        overlapInBetween = otherBarStart.isBetween(barStartMoment, barEndMoment)
                          || otherBarEnd.isBetween(barStartMoment, barEndMoment)
        return overlapLeft || overlapRight || overlapInBetween
      })
      let overlapType = overlapLeft ? "left" : (overlapRight ? "right" : (overlapInBetween ? "left" : null))
      return {overlapBar, overlapType}
    },

    // this is used in GGanttChart, when a bar from a bundle is pushed
    // so that bars from its bundle also get pushed
    moveBarByMinutesAndPush(minuteCount, direction){
      switch(direction){
        case "left":
          this.barStartMoment = moment(this.barStartMoment).subtract(minuteCount, "minutes", true)
          this.barEndMoment = moment(this.barEndMoment).subtract(minuteCount, "minutes", true)
          break
        case "right":
          this.barStartMoment = moment(this.barStartMoment).add(minuteCount, "minutes", true)
          this.barEndMoment = moment(this.barEndMoment).add(minuteCount, "minutes", true)
          break
        default:
          console.warn("wrong direction in moveBarByMinutesAndPush")
          return
      }
      this.manageOverlapping()
    },
    /* --------------------------------------------------------- */
    /* ------- MAPPING POSITION TO TIME (AND VICE VERSA) ------- */
    /* --------------------------------------------------------- */
    mapTimeToPosition(time){
      let hourDiffFromStart = moment(time).diff(this.chartStartMoment, "hour", true)
      return (hourDiffFromStart / this.newHoursCounter) * this.barContainer.width
    },

    mapPositionToTime(xPos){
      let hourDiffFromStart = (xPos/this.barContainer.width) * this.newHoursCounter
      return this.chartStartMoment.clone().add(hourDiffFromStart, "hours")
    },
  },

  filters:{
    TimeFilter(value){
      return moment(value).format("YYYY.MM.DD")
    }
  },

  watch: {
      barStartMoment: function (val) {
          this.localStartMoment = this.mapTimeToPosition(val)
      },
      barEndMoment: function (val) {
          this.localEndMoment = this.mapTimeToPosition(val)
      }
  }

}
</script>

<style scoped>
  .g-gantt-bar {
    position: absolute;
    top: 2px;
    left: 30px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    color: white;
    width: 300px;
    height: 34px;
    border-radius: 15px;
    background: #79869c;
    overflow: hidden;
    transition: none;
  }

  .g-gantt-bar:hover .g-gantt-bar-handle-left {
    background: rgba(0, 0, 0, 0.2);
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    width: 25px;
  }

  .g-gantt-bar:hover .g-gantt-bar-handle-right {
    background: rgba(0, 0, 0, 0.2);
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    width: 25px;
  }

  .g-gantt-bar-label {
    width: 100%;
    height: 100%;
    box-sizing: border-box;
    padding: 0 32px 0 32px;   /* 14px is the width of the handle */
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  .g-gantt-bar-label > * {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  .g-gantt-bar > .g-gantt-bar-handle-left, .g-gantt-bar > .g-gantt-bar-handle-right {
    position: absolute;
    width: 0;
    height: 25px;
    background: rgba(0, 0, 0, 0);
    border-radius: 20px;
    /* opacity: 0.7; */
    cursor: w-resize;
  }

  .g-gantt-bar-handle-left {
    left: 5px;
  }

  .g-gantt-bar-handle-right {
    right: 5px;
  }

  .g-gantt-bar-label img {
    pointer-events: none;
  }

  .g-gantt-tooltip{
    position: absolute;
    background: black;
    color: white;
    z-index: 3;
    font-size: 0.70em;
    padding: 3px;
    border-radius: 3px;
    transition: opacity 0.2s;
    display: flex;
    align-items: center;
  }

  .g-gantt-tooltip:before {
    content: '';
    position: absolute;
    top: 0;
    left: 10%;
    width: 0;
    height: 0;
    border: 10px solid transparent;
    border-bottom-color: black;
    border-top: 0;
    margin-left: -5px;
    margin-top: -5px;
  }

  .g-gantt-tooltip > .color-indicator {
    width: 8px;
    height: 8px;
    border-radius: 100%;
    margin-right: 4px;
  }

  .controls-container {
    min-width: 70px;
  }

  .controlsAbsolute {
    position: absolute;
    left: 0;
    width: 100%;
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    opacity: 0.6;
  }

  .box-shadow-primary {
    box-shadow: -1px 1px 2px #0055a3;
  }

  .box-shadow-primary:hover {
    box-shadow: -2px 1px 3px #0055a3;
  }

  .box-shadow-secondary {
    box-shadow: -1px 1px 2px #3e444c;
  }
  .box-shadow-secondary:hover {
    box-shadow: -2px 1px 3px #3e444c;
  }

  .box-shadow-success {
    box-shadow: -1px 1px 2px #1e7035;
  }
  .box-shadow-success:hover {
    box-shadow: -2px 1px 3px #1e7035;
  }

  .box-shadow-danger {
    box-shadow: -1px 1px 2px #9b232e;
  }
  .box-shadow-danger:hover {
    box-shadow: -2px 1px 3px #9b232e;
  }

  .box-shadow-warning {
    box-shadow: -1px 1px 2px #a27a07;
  }
  .box-shadow-warning:hover {
    box-shadow: -2px 1px 3px #a27a07;
  }

  .box-shadow-info {
    box-shadow: -1px 1px 2px #126b7d;
  }
  .box-shadow-info:hover {
    box-shadow: -2px 1px 3px #126b7d;
  }

  .box-shadow-undefined {
    box-shadow: -1px 1px 2px #4a5262;
  }
  .box-shadow-undefined:hover {
    box-shadow: -2px 1px 3px #4a5262;
  }

  .fade-enter-active {
    animation: fade-in .3s;
  }

  .fade-leave-active {
    animation: fade-in .3s reverse;
  }

  @keyframes fade-in {
    from {
      opacity: 0;
    } to {
      opacity: 1;
    }
  }
</style>
